import sstv from '../api/auth';
import types from '../constants';

export const getQRCodeClientInfo = qid => dispatch => {
  dispatch({
    type: types.GET_QRCODE_CLIENT_LOADING,
    payload: {
      meta: {
        status: 'loading',
        error: ''
      },
      data: []
    }
  });
  return sstv.getQRCodeClientInfo(qid).then(result => {
    if (result.meta.status === 'error') {
      dispatch({
        type: types.GET_QRCODE_CLIENT_ERROR,
        payload: result
      });
    } else {
      dispatch({
        type: types.GET_QRCODE_CLIENT_SUCCESS,
        payload: result
      });
    }
  });
};

export const postQrCodeLogin = id => (dispatch, getState) => {
  const token = getState().user.token
    ? getState().user.token
    : getState().runtime.gt;
  dispatch({
    type: types.POST_QRCODE_LOGIN_LOADING,
    payload: {
      meta: {
        postStatus: 'loading',
        postError: ''
      },
      data: []
    }
  });
  return sstv.postQrCodeLogin(id, token).then(result => {
    if (result.meta.postStatus === 'error') {
      dispatch({
        type: types.POST_QRCODE_LOGIN_ERROR,
        payload: result
      });
    } else {
      dispatch({
        type: types.POST_QRCODE_LOGIN_SUCCESS,
        payload: result
      });
    }
  });
};
